import React, { memo, useMemo } from 'react'
import * as Styled from './styled'
import ModelGroupItem from './ModelGroupItem'
import {
  IGroupMeta,
  IModelGroup,
  IDropdownModel,
  IUnlimitedBanner
} from './types'
import { groupModels } from './utils'

interface IProps {
  models: IDropdownModel[]
  selectedKey: string | null
  groupMeta: Record<string, IGroupMeta>
  onSelect: (model: IDropdownModel) => void
  unlimitedBanner?: IUnlimitedBanner
  getGroupLabels?: (group: IModelGroup) => string[]
  onInnerSlideUpOpenChange?: (open: boolean) => void
}

const GroupedModelList: React.FC<IProps> = ({
  models,
  selectedKey,
  groupMeta,
  onSelect,
  unlimitedBanner,
  getGroupLabels,
  onInnerSlideUpOpenChange
}) => {
  const groups = useMemo(
    () => groupModels(models, groupMeta),
    [models, groupMeta]
  )

  return (
    <Styled.DropdownListWrapper>
      {groups.map(group => (
        <ModelGroupItem
          key={group.key}
          group={group}
          selectedKey={selectedKey}
          onSelect={onSelect}
          unlimitedBanner={unlimitedBanner}
          labels={getGroupLabels?.(group)}
          onMobileExpandChange={onInnerSlideUpOpenChange}
        />
      ))}
    </Styled.DropdownListWrapper>
  )
}

export default memo(GroupedModelList)
